const permissions = {
  console: 'CM001',
  cancelNotifications: 'CM002'
};

export default permissions;
